import { render } from "./EmoteControls.vue?vue&type=template&id=90bad63e&scoped=true&ts=true"
import script from "./EmoteControls.vue?vue&type=script&lang=ts"
export * from "./EmoteControls.vue?vue&type=script&lang=ts"

import "./EmoteControls.vue?vue&type=style&index=0&id=90bad63e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90bad63e"]])

export default __exports__